<template>
    <div>
        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-if="isDesktop()" class="row wrap justify-content-center mt-5" style="margin-bottom:10%">
            <v-container  style="padding-right:25px!important;padding-bottom:25px!important; padding-left:15px!important">
                <v-flex pt-4>
                    <v-toolbar dark flat color="rgba(255,164,9,0.8)">
                        <v-toolbar-title class=" text-center ml-5 pl-5">
                            <img src="../assets/img/pictos/credit-card.png" alt="Devis Sante" width="10%">
                            <span style="font-size: 25px" class="georgia"> Numéro Devis :  {{Devis_pour_souscription.numeroDevis}}</span>
                        </v-toolbar-title>
                    </v-toolbar>
                    <p class="red--text font-weight-bold text-center georgia"> Vous serez redirigé vers la page
                        d’accueil dans {{Mano}} mn</p>
                </v-flex>

                <div class="row block-content elevation-0 p-2 grey lighten-5 border ml-4 mr-4">
                    <v-flex style="text-align:left;">
                        <span class="font-weight-black headline georgia orange--text">1 offre</span>
                        <p class="orange--text georgia">Toutes Vos Assurances en un seul endroit et en toute Sécurité
                            !</p>
                    </v-flex>
                </div>

                <v-flex xs12 pb-3 justify-content-center
                        class="row wrap-content elevation-0 row-container mt-2 ml-1 border grey lighten-3 border-radius">
                    <!--logo Assureur et Notation étoilée-->
                    <v-flex xs4 sm2 class="pt-4  ml-5" justify-content-center column>
                        <img :src="this.$store.state.devis.result.partenaire.logo" alt="logo partenaire" width="130" height="100">
                        <p class="georgia font-weight-black pl-5">
                            {{this.$store.state.devis.result.partenaire.societe}}</p>
                    </v-flex>

                    <!--Tarifs-->
                    <v-flex xs4 pt-5 justify-content-center row>
                        <v-flex>
                            <ul class="List-cout pl-5">
                                <li>
                                    <p v-if="Devis_pour_souscription.prime_ttc" class="font-weight-bold text-center"
                                       style="font-size:25px;color:#ffa409">
                                        {{Devis_pour_souscription.prime_ttc.toLocaleString()}}<small>FCFA</small>
                                    </p>
                                </li>
                                <span class="font-weight-black title justify-center row georgia">Prime TTC</span>
                                <p><small class="title font-weight-light justify-center row georgia">(Frais et taxes
                                    inclus)</small></p>
                            </ul>
                        </v-flex>
                    </v-flex>

                    <!--bouttons ...-->
                    <v-flex xs4 mt-4 class="right--texting">
                        <ul class="list-boutons">
                            <li>
                                <v-btn small @click="assistanceDialogManip(Devis_pour_souscription)" color="default"
                                       class="col-lg-6 col-sm-6 col-md-6 georgia">
                                    <i class="material-icons pr-4 icon-action-devis" aria-hidden="true" data-nosnippet style="margin-left:-3%">&#xe0cf;</i>Être
                                    Rappelé
                                </v-btn>
                            </li>
                            <li>
                                <v-btn small color="default" @click="devisParMail(Devis_pour_souscription)"
                                       class="col-lg-6 col-sm-6 col-md-6 georgia">
                                    <i class="material-icons pr-4 icon-action-devis" aria-hidden="true" data-nosnippet>&#xe0be;</i> Devis par mail
                                </v-btn>
                            </li>
                            <li>
                                <v-btn small color="default" @click="telecharger_le_devis(Devis_pour_souscription)"
                                       class="col-lg-6 col-sm-6 col-md-6 georgia">
                                    <i class="material-icons pr-4 icon-action-devis" aria-hidden="true" data-nosnippet style="margin-left:-3%">&#xe2c4;</i>
                                    Télécharger
                                </v-btn>
                            </li>
                        </ul>
                    </v-flex>
                </v-flex>

                <v-flex row justify-content-center v-if="showPaymentBLock==false">
                    <v-btn @click="show=true" color="#ffa409" class="text-white font-weight-bold georgia mb-2 mt-2"
                           style="border-radius:20px">Souscrire
                    </v-btn>
                </v-flex>

                <v-flex v-show="showPaymentBLock==true">
                    <v-flex xs12 pb-3 justify-content-center
                            class="row block-content elevation-0 row-container mt-3 ml-1 border grey lighten-3 border-radius">
                        <v-flex xs11 sm10 md11 lg11 pt-3 class="justify-content-center row">
                            <p class="font-weight-black headline georgia">Détails de la couverture</p>
                        </v-flex>

                        <v-flex justify-content-center xs11 sm10 md11 lg11
                                class="row block-content elevation-0 row-container bg-transparent ">
                            <v-flex xs12 sm12 md12 lg12
                                    class="table-responsive row block-content elevation-0 row-container bg-transparent ">
                                <table class="table table-sm table-bordered text-center grey lighten-5 table-donnees">
                                    <thead class="bg-light georgia">
                                    <tr>
                                        <th class="head">Objet(s) couvert(s)</th>
                                        <th class="head">Pack(s) souscrit(s)</th>
                                        <th class="head">Autres informations</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <!--============================================Details SANTE===================================================-->
                                        <td>
                                            <ul class="to-left mb-3 georgia" style="width:100%">
                                                <li class="font-weight-regular subheading">Catégorie client : <span
                                                        class="to-right georgia">{{this.$store.state.devis.result.devis.details_pack_sante.packChoisis[0].groupe_ou_individuel}}</span>
                                                </li>
                                                <li class="font-weight-regular subheading">Branche : <span
                                                        class="to-right georgia">{{this.$store.state.devis.result.branche[0].branche}}</span>
                                                </li>
                                            </ul>
                                        </td>

                                        <!--============================================Liste Garanties SANTE===================================================-->
                                        <td>
                                            <ul class="to-left georgia" style="width:100%;margin-bottom: -10%">
                                                <li class="font-weight-regular subheading">Pack(s) :</li>
                                            </ul>

                                            <ul class="to-left mb-1 georgia" style="width:100%"
                                                v-for="(g, index) in tab_pack" :key="index">
                                                <li class="font-weight-regular subheading">
                                                    <span class="to-right font-weight-bold georgia">{{g.nompack}}</span>
                                                </li>
                                            </ul>

                                            <ul class="to-left mb-3 georgia" style="width:100%">
                                                <li class="font-weight-regular subheading"> Période :<span
                                                        class="to-right font-weight-bold georgia">{{this.$store.state.devis.result.devis.details_pack_sante.packChoisis[0].periode}}</span>
                                                </li>
                                            </ul>
                                        </td>

                                        <!--============================================Autres informations===================================================-->
                                        <td>
                                            <ul class="to-left mb-3 georgia" style="width:100%">
                                                <li class="font-weight-regular subheading"> Date D'effet :<span
                                                        class="to-right"> {{DateFormater(Devis_pour_souscription.dateEffet)}} </span>
                                                </li>
                                                <li class="font-weight-regular subheading"> Date D'échéance :<span
                                                        class="to-right"> {{DateFormater(Devis_pour_souscription.dateEcheance)}} </span>
                                                </li>
                                                <li class="font-weight-regular subheading"> Partenaire :<span
                                                        class="to-right font-weight-bold georgia">{{this.$store.state.devis.result.partenaire.societe}}</span>
                                                </li>
                                                <li class="font-weight-regular subheading"> Date de souscription : <span
                                                        class="to-right"> {{DateFormater(Devis_pour_souscription.dateSouscription)}} </span>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </v-flex>
                        </v-flex>

                        <v-flex justify-content-center xs11 sm10 md11 lg11
                                class="row block-content elevation-0 row-container bg-transparent ">
                            <table class="table table-sm table-bordered text-center grey lighten-5 table-donnees">
                                <thead class="bg-light georgia">
                                <tr>
                                    <th class="head">Genre</th>
                                    <th class="head">Prénom</th>
                                    <th class="head">Nom</th>
                                    <th class="head">Téléphone</th>
                                    <th class="head">Adresse</th>
                                    <th class="head">CNI ou Passeport</th>
                                    <th class="head">Nationalité</th>
                                </tr>
                                </thead>
                                <tbody v-for="item in tab_perso" :key="item">
                                <tr>
                                    <td class="font-weight-regular subheading border">{{item.genre}}</td>
                                    <td class="font-weight-regular subheading border">{{item.prenom}}</td>
                                    <td class="font-weight-regular subheading border">{{item.nom}}</td>
                                    <td class="font-weight-regular subheading border">{{item.telephone}}</td>
                                    <td class="font-weight-regular subheading border">{{item.adresse}}</td>
                                    <td class="font-weight-regular subheading border">{{item.numero_cni}}</td>
                                    <td class="font-weight-regular subheading border">{{item.pays}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </v-flex>
                    </v-flex>

                    <v-flex xs12 pt-3 pb-3 justify-content-center
                            class="row block-content elevation-0 row-container mt-3 ml-1 border grey lighten-3 border-radius">
                        <v-flex xs11 sm10 md11 lg11 class="justify-content-center row">
                            <p class="font-weight-black headline georgia">Checkout</p>
                        </v-flex>

                        <v-card width="500" class="border-radius">
                            <v-toolbar card color="#ffa409" dark>
                                <v-toolbar-title class="georgia">Mode de livraison</v-toolbar-title>
                            </v-toolbar>
                            <div class="col pl-2 border-radius">
                                <v-radio-group full-width v-model="mode_livraison" class="answer georgia">
                                    <v-radio color="#ffa409" class="highlight" label="A domicile (à partir de 1500 FCFA TTC)" @change="adresseLivre = true" value="a_docimicile"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Réseau partenaire (500 FCFA TTC)" value="reseau_partenaire" disabled></v-radio>
                                    <v-flex class="ml-0 row">
                                        <v-radio color="#ffa409" class="highlight" label="Assur'Store (gratuit)" value="locaux_assuraf"></v-radio>
                                        <h6 class="pt-2" @click="aStorMap=true">Voir plan ici</h6>
                                    </v-flex>
                                </v-radio-group>
                            </div>
                        </v-card>

                        <v-card width="500" class="ml-5 border-radius">
                            <v-toolbar card color="#ffa409" dark>
                                <v-toolbar-title class="georgia">Mode de Paiement</v-toolbar-title>
                            </v-toolbar>
                            <div class="col pl-2">
                                <v-radio-group @change="calculFraisPaiement()" full-width v-model="mode_payement" class="answer georgia">
                                    <v-radio color="#ffa409" class="highlight" label="Orange money" value="mobile_money"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Free Money" value="free_money"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Carte Bancaire" value="carte_bancaire"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Autres paiements mobiles" value="autre_paiement"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Intouch" value="intouch" disabled></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Paiement réseau partenaire" value="reseau_partenaire" disabled></v-radio>
                                </v-radio-group>
                            </div>
                        </v-card>

                        <v-flex xs12 mt-2 justify-content-center row v-show="mode_livraison">
                            <span class="h6 mr-1">Prime TTC: <span class="font-weight-bold" style="color: #ffa409">{{ Devis_pour_souscription.prime_ttc.toLocaleString()}}</span><small> FCFA</small></span>
                            --
                            <span class="ml-1 mr-1 h6">Frais livraison: 
                                <span class="font-weight-bold" style="color: #ffa409">{{ fraisLiv }}</span>
                                    <small> FCFA</small>
                                </span>
                            --
                            <span class=" ml-1 h6">Frais paiement: 
                                <span class="font-weight-bold" style="color: #ffa409">{{ fraisPaiement }}</span>
                                <small> FCFA</small>
                            </span>
                        </v-flex>

                        <v-flex xs12 mt-2 justify-content-center class=" text-center bg-transparent" v-show="mode_livraison">
                            <span class="font-weight-black h2"> 
                             TOTAL :
                                <span class="red--text" v-if="mention_ttc">
                                    {{mention_ttc.toLocaleString()}} 
                                </span> <small> FCFA</small>
                            </span>
                        </v-flex>

                        <v-flex xs11 sm10 md11 lg11 class="justify-content-center row">
                            <!--Bouton de Paiement Avec les wallet dispo sur upay -->
                            <v-btn dark color="#ffa409" v-show="mode_payement == 'autre_paiement'" @click="getPay"  class="col-sm-3 georgia border-radius" style="height:40px">Payer</v-btn>
                            <!-- boutton pour carte Bancaire qui appelle la fonction de Orabank -->
                            <v-btn dark  color="#ffa409" v-show="mode_payement == 'carte_bancaire'" @click="payment_Orabank" class="col-sm-3 georgia border-radius" style="height:40px">Payer</v-btn>
                            <!--Bouton de Paiement Par OrangeMoney Assuraf -->
                            <v-btn dark color="#ffa409" v-show="mode_payement == 'mobile_money'" @click="payement_om_start" class="col-sm-3 georgia border-radius" style="height:40px">Payer</v-btn>
                            <!--Bouton de Paiement via code upay cash -->
                            <v-btn dark color="#ffa409" v-show="mode_payement == 'reseau_partenaire'" @click="payment_UpayCash" class="col-sm-3 georgia border-radius" style="height:40px">Payer</v-btn>
                            <!--Bouton de Paiement par Intouch -->
                            <v-btn dark color="#ffa409" v-show="mode_payement == 'intouch'" @click="payement_intouch_start" class="col-sm-3 georgia border-radius"  style="height:40px">Payer</v-btn>
                            <!--Bouton de Paiement par Freemoney -->
                            <v-btn dark color="#ffa409" v-show="mode_payement == 'free_money'" @click="payment_free" class="col-sm-3 georgia border-radius" style="height:40px">Payer</v-btn>
                        </v-flex>
                    </v-flex>
                </v-flex>

                <v-dialog v-model="show" persistent>
                    <v-card elevation="24" class="border-radius georgia">
                        <v-toolbar card color="#ffa409">
                            <span class="font-weight-black title georgia" style="color:#fff">
                                <v-icon color="#fff">&#xe92d;</v-icon>
                                    Informations bénéficiaire(s) 
                            </span>
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show=false" class="float-lg-right" style="color:#fff">
                                <v-icon>&#xe5cd;</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-flex class="border-radius grey lighten-3 column justify-content-center text-center mt-3 ml-3 mr-3">
                            <v-flex>
                                <v-form class="text-center row">
                                    <v-container class="text-center row mt-3">
                                        <v-layout ml-3 mr-3 pt-3 class="justify-content-center">
                                            <v-flex xs12 md4>
                                                <v-radio-group class="justify-content-center row" v-model="genre" row>
                                                    <v-radio color="#ffa409" label="Madame" value="Femme"></v-radio>
                                                    <v-radio color="#ffa409" label="Monsieur" value="Homme"></v-radio>
                                                </v-radio-group>
                                            </v-flex>
                                            <v-flex class="row mr-1">
                                                <!-- <v-select solo v-model="genre" :items="itemsGenre" label="Genre" required hint="Votre genre"></v-select> -->
                                                <v-text-field class="ml-2" v-model="prenom" prepend-inner-icon="person"
                                                              label="Prénom*" required
                                                              hint="Votre prénom complet"></v-text-field>
                                                <v-text-field class="ml-2" v-model="nom" prepend-inner-icon="person"
                                                              label="Nom*" required
                                                              hint="Votre nom complet"></v-text-field>
                                                <v-text-field @keypress="onlyNumber" class="ml-2" v-model="telephone"
                                                              prepend-inner-icon="phone" label="Téléphone*" required
                                                              type="number"
                                                              hint="Votre numéro de téléphone"></v-text-field>
                                            </v-flex>
                                        </v-layout>

                                        <v-layout ml-3 mr-3 pt-1 class="justify-content-center">
                                            <v-flex class="row">
                                                <v-text-field v-model="adresse" prepend-inner-icon="map"
                                                              label="Adresse*" required
                                                              hint="Votre adresse actuelle*"></v-text-field>
                                                <v-text-field class="ml-2" v-model="numero_cni"
                                                              prepend-inner-icon="person" label="CNI ou Passeport*"
                                                              required type="text"
                                                              hint="Numéro CNI ou numéro Passeport"></v-text-field>

                                                <v-flex>
                                                    <label for=""> Nationalité* </label>
                                                    <select solo v-model="pays"
                                                            class="border selectatDesktop col-md-11  pt-3">
                                                        <option v-for="itm in countries" :key="itm.PAYS"
                                                                :value="itm.PAYS">
                                                            {{itm.PAYS}}
                                                        </option>
                                                    </select>
                                                </v-flex>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-form>

                                <v-flex class="row">
                                    <div class="col-sm-12 text-center">
                                        <v-btn class="font-weight-bold text-white georgia" round color="#ffa409"
                                               @click="Detail_info_beneficiaires">Ajouter
                                        </v-btn>
                                    </div>
                                </v-flex>
                            </v-flex>
                        </v-flex>

                        <v-flex xs12 ml-5 mr-5 mb-3 mt-3>
                            <table class="table table-simple text-center">
                                <thead class="bg-light">
                                <tr>
                                    <th>Genre</th>
                                    <th>Prénom</th>
                                    <th>Nom</th>
                                    <th>Téléphone</th>
                                    <th>Adresse</th>
                                    <th>CNI ou Passeport</th>
                                    <th>Nationalité</th>
                                </tr>
                                </thead>
                                <tbody v-for="item in tab_perso" :key="item">
                                <tr>
                                    <td class="border">{{item.genre}}</td>
                                    <td class="border">{{item.prenom}}</td>
                                    <td class="border">{{item.nom}}</td>
                                    <td class="border">{{item.telephone}}</td>
                                    <td class="border">{{item.adresse}}</td>
                                    <td class="border">{{item.numero_cni}}</td>
                                    <td class="border">{{item.pays}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </v-flex>

                        <v-flex class="row" v-if="showValiderBtn">
                            <div class="col-sm-12 text-center">
                                <v-btn class="font-weight-bold text-white georgia" round color="#ffa409"
                                       @click="ManipPaiement()"> Continuer
                                </v-btn>
                            </div>
                        </v-flex>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="aStorMap" fullscreen hide-overlay transition="dialog-bottom-transition"
                          v-if="isDesktop()">
                    <v-card>
                        <v-toolbar card color="#ffa409">
                  <span class="font-weight-black title" style="color:#fff">
                      <v-icon color="#fff">&#xe55b;</v-icon>
                      <span style="font-weight:bold;font-size:14px!important;">Plan d'accès</span>
                  </span>
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="aStorMap=false" class="float-lg-right">
                                <v-icon>&#xe5cd;</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-layout xs10 pa-3 justify-content-center row>
                                <v-flex>
                                    <iframe class="border-radius" width="100%" height="608" id="gmap_canvas"
                                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1808.921643560724!2d-17.463326864934903!3d14.710734999189677!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTTCsDQyJzM4LjciTiAxN8KwMjcnNDUuOCJX!5e1!3m2!1sfr!2ssn!4v1587561379330!5m2!1sfr!2ssn"
                                            frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="adresseLivre" persistent max-width="500" v-if="isDesktop()">
                    <v-card elevation="24" class="border-radius grey lihten-3">
                        <v-toolbar color="#ffa409">
                            <v-toolbar-title class="georgia text-white"> Choix livraison <span style="font-size: 14px">(Dakar et Banlieue)</span>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="cancelPaiement()" class="float-lg-right">
                                <v-icon>&#xe5cd;</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-container class="grey lighten-3">
                            <v-layout class="justify-content-center">
                                <p class="mr-5 mt-2 font-weight-bold georgia">Tarif Normal</p>
                                <p class="mt-2 font-weight-bold georgia" style="margin-left:-1%!important">Tarif
                                    Express</p>
                            </v-layout>

                            <v-layout class="justify-content-center">
                                <v-flex class="justify-content-center container">
                                    <form class="form cf">
                                        <v-flex class="justify-content-center row pt-4" style="margin-top:30px">
                                            <section class="ml-2 justify-conten-center row plan cf">
                                                <v-tooltip top class="ml-4">
                                                    <template v-slot:activator="{ on }">
                                                        <input type="radio" name="radio1" id="dakar_normal"
                                                               value="dakar_normal" v-model="prix_livraison"
                                                               @change="showListCity">
                                                        <label v-on="on" class="free-label" for="dakar_normal"
                                                               style="padding-top:15px;white-space: pre-wrap;">
                                                            Dakar
                                                            <span class="font-weight-bold">1500 FCFA</span>
                                                        </label>
                                                    </template>
                                                    <span>
                                                <strong class="font-weight-bold">Livraison le jour <br> même si contrat jusque <br> midi sinon lendemain</strong>
                                            </span>
                                                </v-tooltip>

                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on }">
                                                        <input :disabled="disable" type="radio" name="radio1"
                                                               id="dakar_express" value="dakar_express"
                                                               v-model="prix_livraison" @change="showListCity">
                                                        <label v-on="on" class="basic-label col" for="dakar_express"
                                                               style="padding-top:15px;white-space: pre-wrap;">
                                                            Dakar
                                                            <span class="font-weight-bold">2000 FCFA</span>
                                                        </label>
                                                    </template>
                                                    <span>
                                                <strong class="font-weight-bold">Livraison dans les 2 heures
                                                    <br/> Service de 8h a 17h
                                                </strong>
                                            </span>
                                                </v-tooltip>
                                            </section>
                                        </v-flex>

                                        <v-flex class="justify-content-center row pt-5" style="margin-top:-25px">
                                            <section class="ml-2 justify-conten-center row row plan cf">
                                                <v-tooltip bottom class="ml-4">
                                                    <template v-slot:activator="{ on }">
                                                        <input type="radio" name="radio1" id="banlieue_normal"
                                                               value="banlieue_normal" v-model="prix_livraison"
                                                               @change="showListCity">
                                                        <label v-on="on" class="premium-label col" for="banlieue_normal"
                                                               style="padding-top:10px;white-space: pre-wrap;">
                                                            Banlieue
                                                            <span class="font-weight-bold">2000 FCFA</span>
                                                        </label>
                                                    </template>
                                                    <span>
                                                <strong class="font-weight-bold">Livraison au plus tard le lendemain</strong>
                                            </span>
                                                </v-tooltip>

                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <input :disabled="disable" type="radio" name="radio1"
                                                               id="banlieue_express" value="banlieue_express"
                                                               v-model="prix_livraison" @change="showListCity">
                                                        <label v-on="on" class="optimium-label col"
                                                               for="banlieue_express"
                                                               style="padding-top:10px;white-space: pre-wrap;">
                                                            Banlieue
                                                            <span class="span font-weight-bold">2500 FCFA</span>
                                                        </label>
                                                    </template>
                                                    <span>
                                                <strong class="font-weight-bold">Livraison dans les 3 heures
                                                    <br/> Service de 8h a 17h
                                                </strong>
                                            </span>
                                                </v-tooltip>
                                            </section>
                                        </v-flex>
                                    </form>
                                </v-flex>
                            </v-layout>

                            <v-layout class="justify-content-center">
                                <v-flex class="ml-5 mr-5">
                                    <v-overflow-btn v-if="ville" :items="ville" class="select" v-model="quartier"
                                                    label="Veuillez selectionner votre quartier" editable
                                                    item-text="quartier" item-value="quartier"
                                                    color="#59595b"></v-overflow-btn>
                                </v-flex>
                            </v-layout>

                            <v-layout class="justify-content-center">
                                <v-text-field class="ml-5 mr-5" prepend-inner-icon="map"
                                              label="Renseigner adresse de livraison "
                                              v-model="adresselivraison"></v-text-field>
                            </v-layout>

                            <v-layout class="justify-content-center">
                                <v-btn round class="font-weight-bold text-white georgia" style="background:red" flat
                                       @click="cancelPaiement()"> Annuler
                                </v-btn>
                                <v-btn round class="font-weight-bold text-white georgia" style="background:#ffa409" flat
                                       @click="getAdressLivraison"> Valider
                                </v-btn>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-dialog>
            </v-container>
        </div>
        <!-- Fin Partie Desktop -->

        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE      ================ -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-if="isMobile()" style="margin-bottom:30%">
            <v-container
                    style="padding-right:25px!important;padding-bottom:25px!important; padding-left:25px!important">
                <v-flex pt-5>
                    <v-toolbar dark flat color="rgba(255,164,9,0.8)">
                        <v-toolbar-title class=" text-center">
                            <img src="../assets/img/pictos/credit-card.png" alt="Devis Auto" width="10%">
                            <span style="font-size: 15px" class="georgia"> № Devis :  {{Devis_pour_souscription.numeroDevis}}</span>
                        </v-toolbar-title>
                    </v-toolbar>
                    <p class="red--text font-weight-bold text-center georgia"> Vous serez redirigé vers la page  d’accueil dans {{Mano}} mn</p>
                </v-flex>

                <div class="row block-content elevation-0 grey lighten-5 border ml-2 mr-4 border-radius">
                    <v-flex xs7 style="text-align:left;">
                        <span class="font-weight-black headline orange--text georgia">1 offre</span>
                        <p class="orange--text georgia">Toutes Vos Assurances en un seul endroit et en toute Sécurité  !</p>
                    </v-flex>
                </div>

                <!--logo Assureur et Notation étoilée-->
                <v-layout column justify-content-center>
                    <v-layout column justify-content-center
                              class="ml-2 mt-3 mb-4 mr-2 row wrap-content elevation-0 row-container grey lighten-3 border border-radius">
                        <v-flex justify-content-center class="mt-2" style="text-align: center">
                            <img :src="this.$store.state.devis.result.partenaire.logo" alt="logo partenaire" width="130" height="50">
                            <p class="font-weight-black georgia">
                                {{this.$store.state.devis.result.partenaire.societe}}</p>
                        </v-flex>

                        <!--bouttons ...-->
                        <v-flex row wrap xs12 sm10 md11 lg11 pt-2>
                            <v-flex row wrap justify-content-center class="right--texting pl-3">
                                <ul class="list-boutons">
                                    <li>
                                        <v-btn small @click="assistanceDialogManip(Devis_pour_souscription)"
                                               color="default" class="col-lg-6 col-sm-6 col-md-6 georgia">
                                            <i class="material-icons pr-4" aria-hidden="true" data-nosnippet>&#xe0cf;</i>Être Rappelé
                                        </v-btn>
                                    </li>

                                    <li>
                                        <v-btn small color="default" @click="devisParMail(Devis_pour_souscription)"
                                               class="col-lg-6 col-sm-6 col-md-6 georgia">
                                            <i class="material-icons pr-4" aria-hidden="true" data-nosnippet>&#xe0be;</i> Devis par mail
                                        </v-btn>
                                    </li>

                                    <li>
                                        <v-btn small color="default"
                                               @click="telecharger_le_devis(Devis_pour_souscription)"
                                               class="col-lg-6 col-sm-6 col-md-6 georgia">
                                            <i class="material-icons pr-4" aria-hidden="true" data-nosnippet>&#xe2c4;</i> Télécharger
                                        </v-btn>
                                    </li>
                                </ul>
                            </v-flex>

                            <v-flex xs12 class="pt-2" justify-content-center v-if="Devis_pour_souscription.prime_ttc">
                                <ul class="List-cout">
                                    <li>
                                        <p v-if="Devis_pour_souscription.prime_ttc"
                                           class="font-weight-black title justify-content-center row"
                                           style="color:#ffa409">
                                            {{Devis_pour_souscription.prime_ttc.toLocaleString()}}
                                            <small class="ml-1">FCFA</small>
                                        </p>
                                    </li>
                                    <span class="font-weight-black title justify-content-center row georgia">Prime TTC</span>
                                    <li><p class="justify-content-center row georgia">(Frais et taxes inclus)</p></li>
                                </ul>
                            </v-flex>
                        </v-flex>

                        <v-flex class="ml-1 row justify-content-center" v-if="showPaymentBLock==false">
                            <v-btn @click="show=true" color="#ffa409"
                                   class="font-weight-bold text-white georgia border-radius mb-2">Souscrire
                            </v-btn>
                        </v-flex>
                    </v-layout>

                    <v-layout v-show="showPaymentBLock==true" column justify-content-center>
                        <v-layout column justify-content-center
                                  class="ml-2 mb-3 mr-2  row wrap-content elevation-0 row-container grey lighten-3 border border-radius">
                            <v-flex class="justify-content-center row">
                                <span class="justify-content-center row font-weight-black title georgia ml-2">Détails de la couverture</span>
                            </v-flex>

                            <v-flex class="row mt-2 georgia" justify-content-center>
                                <!--============================================Details Assurance cas Voyage MOBILE===================================================-->
                                <v-flex justify-content-center ml-3 row>
                                    <v-card width="330">
                                        <v-toolbar card color="rgb(91, 148, 188)" dark>
                                            <v-toolbar-title class="georgia">Objet(s) couvert(s)</v-toolbar-title>
                                        </v-toolbar>
                                        <v-item-group>
                                            <ul class="georgia" style="margin-left:-7%">
                                                <li class="font-weight-regular subheading"> Categorie client : <span
                                                        class="to-right-mobile">{{this.$store.state.devis.result.devis.details_pack_sante.packChoisis[0].groupe_ou_individuel}}</span>
                                                </li>
                                                <li class="font-weight-regular subheading"> Branche : <span
                                                        class="to-right-mobile">{{this.$store.state.devis.result.branche[0].branche}}</span>
                                                </li>
                                            </ul>
                                        </v-item-group>
                                    </v-card>
                                </v-flex>

                                <!--==== others informations for the current DEVIS MOBILE===-->
                                <v-flex justify-content-center ml-3 row class="pt-2">
                                    <v-card width="330">
                                        <v-toolbar card color="rgb(91, 148, 188)" dark>
                                            <v-toolbar-title class="georgia">Pack(s) souscrit(s</v-toolbar-title>
                                        </v-toolbar>
                                        <v-item-group>
                                            <ul class="georgia" style="margin-left:-7%;width:100%;margin-bottom: -10%">
                                                <li class="font-weight-regular subheading"> Nom du pack :</li>
                                            </ul>

                                            <ul class="georgia">
                                                <li class="font-weight-bold subheading" style=""
                                                    v-for="(g, index) in tab_pack" :key="index">
                                                    <span style="margin-left: 48%">{{g.nompack}}</span>
                                                </li>
                                            </ul>

                                            <ul class="georgia" style="margin-left:-7%">
                                                <li class="font-weight-regular subheading"> Période :
                                                    <span class="to-right-mobile">{{this.$store.state.devis.result.devis.details_pack_sante.packChoisis[0].periode}}</span>
                                                </li>
                                            </ul>
                                        </v-item-group>
                                    </v-card>
                                </v-flex>

                                <!--==== others informations for the current DEVIS MOBILE===-->
                                <v-flex justify-content-center ml-3 row class="pt-2">
                                    <v-card width="330">
                                        <v-toolbar card color="rgb(91, 148, 188)" dark>
                                            <v-toolbar-title class="georgia">Autres informations</v-toolbar-title>
                                        </v-toolbar>
                                        <v-item-group>
                                            <ul class="georgia" style="margin-left:-7%">
                                                <li class="font-weight-regular subheading"> Date D'effet :<span
                                                        class="to-right-mobile"> {{DateFormater(Devis_pour_souscription.dateEffet)}} </span>
                                                </li>
                                                <li class="font-weight-regular subheading"> Date D'échéance :<span
                                                        class="to-right-mobile"> {{DateFormater(Devis_pour_souscription.dateEcheance)}} </span>
                                                </li>
                                                <li class="font-weight-regular subheading"> Partenaire :<span
                                                        class="to-right-mobile">{{this.$store.state.devis.result.partenaire.societe}}</span>
                                                </li>
                                                <li class="font-weight-regular subheading"> Date de souscription : <span
                                                        class="to-right-mobile"> {{DateFormater(Devis_pour_souscription.dateSouscription)}} </span>
                                                </li>
                                            </ul>
                                        </v-item-group>
                                    </v-card>
                                </v-flex>

                                <v-flex justify-content-center ml-3 row class="pt-2">
                                    <table class="table table-simple text-center">
                                        <thead class="bg-light georgia">
                                        <tr>
                                            <th class="head">Prénom</th>
                                            <th class="head">Nom</th>
                                        </tr>
                                        </thead>
                                        <tbody v-for="item in tab_perso" :key="item.prenom">
                                        <tr style="background:#fff">
                                            <td class="font-weight-regular subheading border">{{item.prenom}}</td>
                                            <td class="font-weight-regular subheading border">{{item.nom}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </v-flex>
                            </v-flex>
                        </v-layout>

                        <v-flex justify-content-center row class=" ml-2 mr-2 grey lighten-3 border border-radius">
                            <v-flex class="justify-content-center row">
                                <span class="font-weight-black headline georgia">Checkout</span>
                            </v-flex>

                            <v-card width="300" class="border-radius">
                                <v-toolbar card color="#ffa409" dark>
                                    <v-toolbar-title class="georgia">Mode de livraison</v-toolbar-title>
                                </v-toolbar>
                                <v-item-group style="margin-top:-12px">
                                    <ul>
                                        <v-radio-group full-width v-model="mode_livraison" class="answer georgia">
                                            <v-radio color="#ffa409" class="highlight" label="A domicile  (à partir de 1500 FCFA TTC)"  @change="adresseLivre = true" value="a_docimicile"></v-radio>
                                            <v-radio color="#ffa409" class="highlight" label="Réseau partenaire  (500 FCFA TTC)" value="reseau_partenaire" disabled></v-radio>
                                            <v-radio color="#ffa409" class="highlight" label="Assur'Store (gratuit)" value="locaux_assuraf"></v-radio>
                                            <h6 class="ml-5" @click="aStorMap=true">Voir plan ici</h6>
                                        </v-radio-group>
                                    </ul>
                                </v-item-group>
                            </v-card>

                            <v-card width="300" class="mt-2 border-radius">
                                <v-toolbar card color="#ffa409" dark>
                                    <v-toolbar-title class="georgia">Mode de paiement</v-toolbar-title>
                                </v-toolbar>
                                <v-item-group style="margin-top:-12px">
                                    <ul>
                                        <v-radio-group @change="calculFraisPaiement()" full-width v-model="mode_payement" class="answer georgia">
                                            <v-radio color="#ffa409" class="highlight" label="Orange Money" value="mobile_money"></v-radio>
                                            <v-radio color="#ffa409" class="highlight" label="Free Money" value="free_money"></v-radio>
                                            <v-radio color="#ffa409" class="highlight" label="Carte Bancaire" value="carte_bancaire"></v-radio>
                                            <v-radio color="#ffa409" class="highlight" label="Autres paiements mobiles" value="autre_paiement"></v-radio>
                                            <v-radio color="#ffa409" class="highlight" label="Intouch" value="intouch" disabled></v-radio>
                                            <v-radio color="#ffa409" class="highlight" label="Paiement réseau partenaire" value="reseau_partenaire" disabled></v-radio>
                                        </v-radio-group>
                                    </ul>
                                </v-item-group>
                            </v-card>

                            <v-flex xs8 justify-content-center column class="ml-5 bg-transparent"
                                    v-show="mode_livraison">
                                <span class="h6">Prime TTC: <span class="font-weight-bold" style="color: #ffa409">{{ Devis_pour_souscription.prime_ttc.toLocaleString() }}</span><small> FCFA</small></span><br>
                                <span class="h6">Frais livraison: <span class="font-weight-bold" style="color: #ffa409">{{ fraisLiv }}</span><small> FCFA</small></span><br>
                                <span class="h6">Frais paiement: <span class="font-weight-bold" style="color: #ffa409">{{ fraisPaiement }}</span><small> FCFA</small></span>
                            </v-flex>

                            <v-flex xs12 justify-content-center row class="bg-transparent" v-show="mode_livraison">
                                <span class="font-weight-black h2">
                                    TTC : 
                                    <span class="red--text">
                                        {{mention_ttc.toLocaleString()}}
                                    </span> 
                                    <small> FCFA</small> 
                                </span>
                            </v-flex>

                            <div class="row block-content elevation-0 row-container bg-transparent">
                                <v-flex xs11 sm10 md11 lg11 class="justify-content-center row">
                                    <!--Bouton de Paiement Avec les wallet dispo sur upay  -->
                                    <v-btn dark color="#ffa409" v-show="mode_payement == 'autre_paiement'" @click="getPay" class="col-sm-3 georgia border-radius" style="height:40px">Payer</v-btn>
                                    <!-- boutton pour carte Bancaire qui appelle la fonction de Orabank -->
                                    <v-btn dark color="#ffa409" v-show="mode_payement == 'carte_bancaire'" @click="payment_Orabank" class="col-sm-3 georgia border-radius" style="height:40px">Payer</v-btn>
                                    <!--Bouton de Paiement Par OrangeMoney Assuraf-->
                                    <v-btn dark color="#ffa409" v-show="mode_payement == 'mobile_money'" @click="payement_om_start" class="col-sm-3 georgia border-radius" style="height:40px">Payer </v-btn>
                                    <!--Bouton de Paiement via code upay cash-->
                                    <v-btn dark color="#ffa409" v-show="mode_payement == 'reseau_partenaire'" @click="payment_UpayCash" class="col-sm-3 georgia border-radius" style="height:40px">Payer</v-btn>                               
                                    <!-- boutton pour carte Bancaire qui appelle la fonction de inTouch -->
                                    <v-btn dark color="#ffa409" v-show="mode_payement == 'intouch'" @click="payement_intouch_start" class="col-sm-3 georgia border-radius" style="height:40px">Payer</v-btn>
                                     <!--Bouton de Paiement par Freemoney -->
                                    <v-btn dark color="#ffa409" v-show="mode_payement == 'free_money'" @click="payment_free" class="col-sm-3 georgia border-radius" style="height:40px">Payer</v-btn>
                                </v-flex>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-layout>

                <v-dialog v-model="show" persistent>
                    <v-card elevation="24" class="georgia border-radius scroll">
                        <v-toolbar card color="#ffa409">
                            <span class="font-weight-black title" style="color:#fff">
                                <v-icon color="#fff">&#xe92d;</v-icon>
                                <span style="font-weight:bold;font-size:14px!important;"> 
                                    Informations bénéficiaire(s) 
                                </span>
                            </span>
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show=false" class="float-lg-right" style="color:#fff">
                                <v-icon>&#xe5cd;</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-flex class="border-radius grey lighten-3 row mt-2 ml-3 mr-3">
                            <v-flex class="ml-3 mr-3">
                                <v-form>
                                    <v-container class="georgia">
                                        <v-layout column pl-2 pr-2>
                                            <v-flex xs12 md6>
                                                <v-radio-group class="justify-content-center row" v-model="genre" row>
                                                    <v-radio color="#ffa409" label="Madame" value="Femme"></v-radio>
                                                    <v-radio color="#ffa409" label="Monsieur" value="Homme"></v-radio>
                                                </v-radio-group>
                                            </v-flex>

                                            <v-flex xs12 md6 class="to-top">
                                                <v-text-field v-model="prenom" prepend-inner-icon="person"
                                                              label="Prénom*" required
                                                              hint="Votre nom complet"></v-text-field>
                                            </v-flex>

                                            <v-flex xs12 md6 class="to-top">
                                                <v-text-field v-model="nom" prepend-inner-icon="person" label="Nom*"
                                                              required hint="Votre prénom complet"></v-text-field>
                                            </v-flex>
                                        </v-layout>

                                        <v-layout column pl-2 pr-2>
                                            <v-flex xs12 md6 class="to-top">
                                                <v-text-field v-model="adresse" prepend-inner-icon="map"
                                                              label="Adresse*" required
                                                              hint="Votre adresse actuelle (*)"></v-text-field>
                                            </v-flex>

                                            <v-flex xs12 md6 class="to-top">
                                                <v-text-field @keypress="onlyNumber" v-model="telephone"
                                                              prepend-inner-icon="phone" label="Téléphone*" required
                                                              type="number"
                                                              hint="Votre numéro de téléphone"></v-text-field>
                                            </v-flex>
                                        </v-layout>

                                        <v-layout column pl-2 pr-2>
                                            <v-flex xs12 md6 class="to-top">
                                                <v-text-field v-model="numero_cni" prepend-inner-icon="person"
                                                              label="CNI ou Passeport*" required type="text"
                                                              hint="Numéro CNI ou numéro Passeport"></v-text-field>
                                            </v-flex>

                                            <v-flex xs12 md6 class="to-top">
                                                <label for="" class="ml-1"> Nationalité* </label>
                                                <select v-model="pays" class="col-md-4 selectatMobile pt-2">
                                                    <option v-for="itm in countries" :key="itm.PAYS" :value="itm.PAYS">
                                                        {{itm.PAYS}}
                                                    </option>
                                                </select>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-form>

                                <v-flex class="justify-content-center row ml-1">
                                    <v-btn class="font-weight-bold text-white justify-content-center row georgia" round
                                           color="#ffa409" @click="Detail_info_beneficiaires"> Ajouter
                                    </v-btn>
                                </v-flex>
                            </v-flex>
                        </v-flex>

                        <v-flex class="row text-center ml-3 mr-3 mt-3">
                            <table class="table table-simple text-center">
                                <thead class="bg-light">
                                <tr>
                                    <th>Prénom</th>
                                    <th>Nom</th>
                                </tr>
                                </thead>
                                <tbody v-for="item in tab_perso" :key="item.prenom">
                                <tr>
                                    <td class="border">{{item.prenom}}</td>
                                    <td class="border">{{item.nom}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </v-flex>

                        <v-flex class="justify-content-center ml-1 row" v-if="showValiderBtn">
                            <v-btn class="font-weight-bold text-white georgia" round color="#ffa409"
                                   @click="ManipPaiement()"> Continuer
                            </v-btn>
                        </v-flex>
                    </v-card>
                </v-dialog>
            </v-container>
        </div>
        <!-- Fin Partie Mobile -->

        <!-- popup pour loading -->
         <div v-if="dialogLoading" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">Génération du fichier en cours</span>
    </div>

        <v-dialog v-model="dialogLoading" hide-overlay persistent width="300">
            <v-card color="orange" dark>
                <v-card-text>
                    Génération du fichier en cours
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- popup pour demande d'assistance -->
        <v-dialog v-model="assistanceDialog" max-width="800">
            <v-card class="border-radius georgia">
                <v-toolbar card dark style="background: #ffa409">
                    <v-toolbar-title>Assistance</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark flat @click="assistanceDialog= false" class="float-lg-right">
                        <v-icon>&#xe5cd;</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-container class=" scroll">
                        <v-layout wrap>
                            <div id="app" class="col-md-12">
                                <v-app id="inspire" class="georgia">
                                    <v-form ref="form">
                                        <v-flex xs12 sm12 md12 class="text-lg-center">
                                            <label for="" class="greyLabel"> Horaire de rappel (*) </label>
                                            <select v-model="horaire" class="border col-md-11 selectatDesktop pt-2">
                                                <option v-for="itm in itema" :key="itm" :value="itm">
                                                    {{itm}}
                                                </option>
                                            </select>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12 class="text-lg-center ">
                                            <label for="" class="greyLabel"> Canal de rappel (*) </label>
                                            <select v-model="canal" class="border col-md-11 selectatDesktop pt-2">
                                                <option v-for="itm in rappel" :key="itm" :value="itm">
                                                    {{itm}}
                                                </option>
                                            </select>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12 class="text-lg-center">
                                            <v-text-field label="Nom" prepend-inner-icon="portrait" v-model="name"
                                                          :counter="20" required></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12 class="text-lg-center">
                                            <v-text-field label="Téléphone" prepend-inner-icon="call" v-model="tel"
                                                          prefix="(+221)" type="number" value="0" :counter="9"
                                                          required></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12 class="text-lg-center ">
                                            <v-text-field label="Objet" prepend-inner-icon="link" disabled
                                                          v-model="objetRappel" required></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12 class="text-lg-center ">
                                            <v-textarea name="input-7-1" v-model="remarques" box label="Remarque (s)"
                                                        prepend-inner-icon="feedback" auto-grow></v-textarea>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12 class="justify-content-center row">
                                            <v-btn round class="font-weight-bold text-white georgia" color="red"
                                                   style="background-color:grey">Supprimer
                                                <v-icon style="font-size:20px;">&#xe872;</v-icon>
                                            </v-btn>
                                            <v-btn round color="#ffa409" class="font-weight-bold text-white georgia"
                                                   @click="AddAssistance()">valider
                                                <v-icon style="font-size:20px;">&#xe876;</v-icon>
                                            </v-btn>
                                        </v-flex>
                                    </v-form>
                                </v-app>
                            </div>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="freepayment" max-width="1000" v-if="isDesktop()">
            <div class="containerP scroll" style="min-width:1000px;width:auto">
                <div class="icing">
                    <h3>{{this.description}}</h3>
                    <ul class="order" style>
                        <li>
                            <span class="item-name" style="font-size: 12px;">1 - Renseignez votre numéro de téléphone FreeMoney et cliquez sur « CONFIRMER LE PAIEMENT ».</span>
                        </li>
                        <br/>
                        <li>
                            <span class="item-name" style="font-size: 12px;">2 Avec votre téléphone portable composez le #150# et validez la transaction avec votre code secret.</span>
                        </li>
                        <br/>
                        <li>
                        <span class="item-name" style="font-size: 12px;">3 - Le paiement est valide, vous recevrez un sms de confirmation.
                          <br/>
                        </span>
                        </li>
                    </ul>

                    <div style="margin-top:-10px;">
                        <p>Montant à payer</p>
                    </div>

                    <div class="total" style="font-size: 25px;margin-top:-10px;">{{ mention_ttc.toLocaleString() }}
                        <small>XOF</small>
                    </div>
                </div>

                <div class="dough">
                    <div class="col">
                        <div>
                            <h2>Payez par
                                <span><img src="../assets/img/freemoney.png" alt="free-money-logo" width="25%"/></span>
                            </h2>
                        </div>
                    </div>

                    <div class="inputs">
                        <div class="row"></div>
                        <div class="justify-content-center row rowFree mt-3">
                            <v-flex md5 class="justify-content-center rowFree">
                                <div class="column card-group">
                                    <div>
                                        <label class="label">Nom</label>
                                        <input class="text-input name-input" name="nom" :placeholder="placeholdernom"
                                               disabled/>
                                    </div>
                                </div>
                            </v-flex>

                            <v-flex md5 class="ml-5 justify-content-center rowFree">
                                <div class="column card-group">
                                    <div>
                                        <label class="label">Prénom</label>
                                    </div>
                                    <div>
                                        <input class="text-input name-input" name="prenom"
                                               :placeholder="placeholderprenom" disabled/>
                                    </div>
                                </div>
                            </v-flex>
                        </div>

                        <div class="row" style="margin-left:30px">
                            <v-flex md11 class="justify-content-center row rowFree">
                                <div class="column name-group">
                                    <label class="label" for="telephone">Numéro Téléphone *</label>
                                    <input class="text-input card-input" name="phone" v-model="numTelephone"/>
                                </div>
                            </v-flex>
                        </div>

                        <div class="justify-center row mt-3">
                        </div>
                    </div>

                    <div class="justify-center row mt-3">
                        <rotate-loader v-show="snipperfree" :loading="loading" :color="color"
                                       :size="size"></rotate-loader>

                    </div>


                    <div class="justify-center rowFree mt-3">
                        <v-flex md7 class="ml-3 justify-content-center rowFree">
                            <div class="column card-group">
                                <button class="order-button" @click="Gopayment_free">Confirmer le paiement</button>
                            </div>
                        </v-flex>

                        <v-flex md4 class="ml-4 justify-content-center rowFree">
                            <button class="order-button" @click="cancelFree()">Annuler</button>
                        </v-flex>
                    </div>
                </div>
            </div>
        </v-dialog>


        <v-dialog v-model="freepayment" max-width="500" v-if="isMobile()">
            <v-card class="border-radius" color="white">
                <v-container>
                    <v-layout class="column">
                        <v-flex class="justify-content-center row ml-1 mt-3">
                            <h2 class="justify-content-center row" style="font-size:18px">Payez par
                                <img src="../assets/img/freemoney.png" alt="free-money-logo" width="20%" style="margin-top:-10px"/>
                            </h2>
                        </v-flex>

                        <v-flex class="mr-3">
                            <ul class="font-weight-bold text-center" style="font-size:12px">
                                <li>1 - Vérifiez votre numéro de téléphone Freemoney puis cliquez« CONFIRMER LE PAIEMENT
                                    ».
                                </li>
                                <li>2 - Faites le #150# sur votre téléphone pour valider le paiement avec votre code
                                    secret
                                </li>
                                <li>3 - Vous recevrez un sms de confirmation du paiement</li>
                            </ul>
                        </v-flex>

                        <div class="inputs">
                            <!-- <div class="ml-2 justify-center rowFree">
                            </div> -->
                            <v-layout class="ml-2 mr-3 row">
                                <v-flex md4 class="ml-4 justify-content-center row rowFreeMobile">
                                    <div class="column card-group">
                                        <div>
                                            <label class="label">Nom</label>
                                            <input
                                                    class="text-input name-input"
                                                    name="nom"
                                                    :placeholder="placeholdernom "
                                                    disabled
                                            />
                                        </div>
                                    </div>
                                </v-flex>
                            </v-layout>

                            <v-layout class="ml-2 mr-3 row">
                                <v-flex md3 class="ml-4 justify-content-center row rowFreeMobile">
                                    <div class="column card-group">
                                        <div>
                                            <label class="label">Prénom</label>

                                            <input class="text-input name-input" name="prenom"
                                                   :placeholder="placeholderprenom " disabled/>
                                        </div>
                                    </div>
                                </v-flex>
                            </v-layout>

                            <v-layout class="ml-2 mr-3 row">
                                <v-flex class="ml-4 justify-content-center row rowFreeMobile">
                                    <div class="column name-group">
                                        <label class="label" for="telephone">Numéro Téléphone *</label>

                                        <input class="text-input card-input" name="phone" v-model="numTelephone"/>
                                    </div>
                                </v-flex>
                            </v-layout>
                            <div class="justify-center row mt-3">
                                <rotate-loader v-show="snipperfree" :loading="loading" :color="color"
                                               :size="size"></rotate-loader>

                            </div>
                        </div>

                        <v-layout class="justify-content-center row ml-1 mr-1 mt-1 mb-3">
                            <v-flex class="justify-content-center row">
                                <div class="card-group">
                                    <button class="highlight buttonFRMobile" @click="Gopayment_free">Confirmer le
                                        paiement
                                    </button>
                                </div>
                            </v-flex>

                            <v-flex class="justify-content-center row">
                                <div class="card-group ">
                                    <button class="order-button" @click="cancelFree()">Annuler</button>
                                </div>
                            </v-flex>


                        </v-layout>
                    </v-layout>
                </v-container>
            </v-card>
        </v-dialog>


        <v-dialog v-model="adresseLivre" persistent max-width="auto" v-if="isMobile()">
            <v-card elevation="24" class="border-radius grey lighten-3">
                <v-toolbar color="#ffa409">
                    <v-toolbar-title class="georgia text-white"> Livraison <span style="font-size: 14px">(Dakar et Banlieue)</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="cancelPaiement()" class="float-lg-right">
                        <v-icon>&#xe5cd;</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-container class="justify-content-center">
                    <v-layout class="justify-content-center row">
                        <v-flex class="justify-content-center row pt-2">
                            <section class="justify-conten-center row plan cf">
                                <p class="font-weight-bold georgia mr-5">Tarif Normal</p>
                                <p class="font-weight-bold georgia" style="margin-left:-6%">Tarif Express</p>
                            </section>
                        </v-flex>
                    </v-layout>

                    <v-layout wrap class="justify-content-center row ml-2 pt-3" style="margin-top:30px">
                        <v-flex class="justify-content-center container">
                            <form class="form cf">
                                <v-flex class="justify-content-center row pt-2">
                                    <section class="justify-conten-center row plan cf">
                                        <v-tooltip top class="ml-2">
                                            <template v-slot:activator="{ on }">
                                                <input type="radio" name="radio1" id="dakar_normal" value="dakar_normal"
                                                       v-model="prix_livraison" @change="showListCity">
                                                <label v-on="on" class="free-label" for="dakar_normal"
                                                       style="padding-top:15px;white-space: pre-wrap;">
                                                    Dakar
                                                    <span class="font-weight-bold">1500 FCFA</span>
                                                </label>
                                            </template>
                                            <span>
                                                <strong class="font-weight-bold">Livraison le jour <br> même si contrat jusque <br> midi sinon lendemain</strong>
                                            </span>
                                        </v-tooltip>

                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <input :disabled="disable" type="radio" name="radio1" id="dakar_express"
                                                       value="dakar_express" v-model="prix_livraison"
                                                       @change="showListCity">
                                                <label v-on="on" class="basic-label col" for="dakar_express"
                                                       style="padding-top:15px;white-space: pre-wrap;">
                                                    Dakar
                                                    <span class="font-weight-bold">2000 FCFA</span>
                                                </label>
                                            </template>
                                            <span>
                                                <strong class="font-weight-bold">Livraison dans les 2 heures
                                                    <br/> Service de 8h a 17h
                                                </strong>
                                            </span>
                                        </v-tooltip>
                                    </section>
                                </v-flex>

                                <v-flex class="justify-content-center row">
                                    <section class="justify-content-center row row plan cf">
                                        <v-tooltip bottom class="ml-2">
                                            <template v-slot:activator="{ on }">
                                                <input type="radio" name="radio1" id="banlieue_normal"
                                                       value="banlieue_normal" v-model="prix_livraison"
                                                       @change="showListCity">
                                                <label v-on="on" class="premium-label col" for="banlieue_normal"
                                                       style="padding-top:25px;white-space: pre-wrap;">
                                                    Banlieue
                                                    <span class="font-weight-bold">2000 FCFA</span>
                                                </label>
                                            </template>
                                            <span>
                                                <strong class="font-weight-bold">Livraison au plus tard le lendemain</strong>
                                            </span>
                                        </v-tooltip>

                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <input :disabled="disable" type="radio" name="radio1"
                                                       id="banlieue_express" value="banlieue_express"
                                                       v-model="prix_livraison" @change="showListCity">
                                                <label v-on="on" class="optimium-label col" for="banlieue_express"
                                                       style="padding-top:25px;white-space: pre-wrap;">
                                                    Banlieue
                                                    <span class="font-weight-bold">2500 FCFA</span>
                                                </label>
                                            </template>
                                            <span>
                                                <strong class="font-weight-bold">Livraison dans les 3 heures
                                                    <br/> Service de 8h a 17h
                                                </strong>
                                            </span>
                                        </v-tooltip>
                                    </section>
                                </v-flex>
                            </form>
                        </v-flex>
                    </v-layout>

                    <v-layout class="justify-content-center">
                        <v-flex class="ml-4 mr-4">
                            <v-overflow-btn v-if="ville" :items="ville" class="select" v-model="quartier"
                                            label="Votre quartier" item-text="quartier" item-value="quartier"
                                            color="#59595b"></v-overflow-btn>
                        </v-flex>
                    </v-layout>

                    <v-layout class="justify-content-center">
                        <v-text-field class="ml-4 mr-4" prepend-inner-icon="map"
                                      label="Renseigner adresse de livraison "
                                      v-model="adresselivraison"></v-text-field>
                    </v-layout>

                    <v-layout class="justify-content-center">
                        <v-btn round class="font-weight-bold text-white georgia" style="background:red" flat
                               @click="cancelPaiement()"> Annuler
                        </v-btn>
                        <v-btn round class="font-weight-bold text-white georgia" style="background:#ffa409" flat
                               @click="getAdressLivraison"> Valider
                        </v-btn>
                    </v-layout>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-model="aStorMap" fullscreen hide-overlay transition="dialog-bottom-transition" v-if="isMobile()">
            <v-card>
                <v-toolbar card color="#ffa409">
                  <span class="font-weight-black title" style="color:#fff">
                      <v-icon color="#fff">&#xe55b;</v-icon>
                      <span style="font-weight:bold;font-size:14px!important;">Plan d'accès</span>
                  </span>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="aStorMap=false" class="float-lg-right">
                        <v-icon>&#xe5cd;</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout xs10 pa-3 justify-content-center row>
                        <v-flex>
                            <iframe class="border-radius" width="100%" height="700" id="gmap_canvas"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1808.921643560724!2d-17.463326864934903!3d14.710734999189677!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTTCsDQyJzM4LjciTiAxN8KwMjcnNDUuOCJX!5e1!3m2!1sfr!2ssn!4v1587561379330!5m2!1sfr!2ssn"
                                    frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    import Api from '../services/Api'
    import store from "./../store/store";
    import getUpay from "../services/getUpaySante"

    import ville from './../common/ville'


    import PushInDataLayer from '../services/TagManager'

    export default {
        data() {
            return {
                placeholderprenom: store.state.user.prenom,
                placeholdernom: store.state.user.nom,
                numTelephone: store.state.user.telephone_port,
                snipperfree: false,
                description: "Paiement de pack " + store.state.devis.result.branche[0].branche + " No: " + store.state.devis.result.devis.numeroDevis + ". Partenaire: " + store.state.devis.result.partenaire.societe,
                freepayment: false,
                aStorMap: false,
                disable: false,
                genre: null,
                myDate: new Date().toISOString().slice(0, 10),
                show: false,
                adresseLivre: false,
                adresselivraison: null,
                Devis_pour_souscription: [],
                prix_livraison: null,
                mode_livraison: null,
                mention_ttc: null,
                mode_payement: null,
                dialogRemplissageBeneficiaire: false,
                notifDeviParMail: null,
                notifDeviSendParMail: null,
                dialogLoading: false,
                frais_livraison: null,
                fraisPaiement: 0,
                fraisLiv: 0,
                listVille: ville,
                ville: null,
                quartier: '',
                branche: null,
                dialog: false,
                showValiderBtn: false,
                showPaymentBLock: false,
                contratToStore: null,
                maxPersonne: null,
                svgTTC: null,
                notif: null,
                countries: null,
                nom: null,
                prenom: null,
                adresse: null,
                telephone: null,
                numero_cni: null,
                pays: null,
                tab_pack: [],
                tab_perso: [],
                ToastTabSucess: {
                    // Customized options for success toast
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 2000,
                    fitToScreen: true,
                    type: 'success',
                    className: 'custom-success-class'
                },
                ToastTabError: {
                    // Customized options for error toast
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 2000,
                    fitToScreen: true,
                    type: 'error',
                },
                Mano: null,

                assistanceDialog: false,
                itemsGenre: ['Homme', 'Femme'],
                itema: ['Le plus tôt possible', 'Dans la matinée', 'Dans la journée'],
                rappel: ['Whatsapp', 'Appel', 'Email'],
                objet: ['Devis', 'Souscription', 'Contrat', 'Paiement', 'Conseil', 'Sinistre', 'Autres'],
                horaire: null,
                canal: null,
                name: null,
                tel: null,
                objetRappel: null,
                remarques: null,
                timer: '',
                addedInTheCard:null
            }
        },
        created() {
            this.fetchEventsList();
            this.timer = setInterval(this.fetchEventsList, 60000);

            // EXECUTION AUTOMATIQUE ET PERIODIQUE DES FONCTIONS POUR 
            // DESACTIVER LES CHOIX EXPRESS DU POPUP LIVRAISON
            let result = this.$crontab.addJob({
                name: 'counter',
                interval: {hours: '17', day: '*'},
                job: this.disableExpress,
            });

            let stop = this.$crontab.addJob({
                name: 'stop',
                interval: {hours: '8', day: '*'},
                job: this.enableExpress,
            })
        },
        
        methods: {
            
        /*=============================================*/
        /*====Push DataLayer Choix du mode Livraison===*/
        add_shipping_infoPushing()
        {
                let itemPushing = {
                    event: 'add_shipping_info',
                    ecommerce: {
                        shipping_tier: this.mode_livraison,
                        items:this.addedInTheCard.ecommerce.items
                    }
                }
                PushInDataLayer(itemPushing)
        },


        /*************************************************/
        /*Push begin_checkout Data and event to DataLayer*/
        /*************************************************/
        begin_checkoutPushin()
        {
                let itemPushing = {
                    event: 'begin_checkout',
                    ecommerce: {
                        items:this.addedInTheCard.ecommerce.items
                    }
                }
                PushInDataLayer(itemPushing)
        },

        /*=============================================================*/
        /*Prepare purchase data to Push purchase event in the dataLayer*/
        /*=============================================================*/ 
        purchasePushinPreparation()
        {
            let value = this.addedInTheCard.ecommerce.items[0].price +  Math.round(this.DeliveryCost/655.957)
            this.addedInTheCard.ecommerce.items[0].item_coupon = ''
            
            let purchasePushin = 
            {
                'event': 'purchase',
                'ecommerce': {
                        'transaction_id': null,
                        'affiliation': '',
                        'value': value,
                        'tax': Math.round(this.Devis_pour_souscription.taxe/655.957),
                        'shipping': Math.round(this.DeliveryCost/655.957),
                        'currency': 'EUR',
                        'coupon': '',
                        'items': this.addedInTheCard.ecommerce.items                    
                }    
            }
            localStorage.setItem('purchasePushin', JSON.stringify(purchasePushin))
        },

        /*====================================*/
        /*====Push DataLayer Payment infon====*/
        add_payment_infoPushing(Payment_Type)
        {
            let itemPushing = {
                event: 'add_payment_info',
                ecommerce: {
                    payment_type:Payment_Type,
                    items:this.addedInTheCard.ecommerce.items
                }
            }
            PushInDataLayer(itemPushing)
        },



            calculFraisPaiement() {
                /**
                 * Orange Money
                 * Free Money
                 * upay cash
                 */
                if (this.mode_payement == 'mobile_money' || this.mode_payement == 'free_money' || this.mode_payement == 'reseau_partenaire') {
                    let FP = (this.Devis_pour_souscription.prime_ttc + this.fraisLiv) * (0.01) / (1 - 0.01);
                    this.fraisPaiement = Math.round(FP * 100) / 100;
                    this.mention_ttc = Math.ceil((this.Devis_pour_souscription.prime_ttc + this.fraisPaiement) + this.fraisLiv)
                }
                /**
                 * OraBank
                 * Intouch
                 */
                else if (this.mode_payement == 'carte_bancaire' || this.mode_payement == 'intouch') {
                    let FP = (this.Devis_pour_souscription.prime_ttc + this.fraisLiv) * (0.02) / (1 - 0.02);
                    this.fraisPaiement = Math.round(FP * 100) / 100;
                    this.mention_ttc = Math.ceil((this.Devis_pour_souscription.prime_ttc + this.fraisPaiement) + this.fraisLiv)
                }
                /**
                 * Upay
                 *
                 */
                else if (this.mode_payement == 'autre_paiement') {
                    let FP = (this.Devis_pour_souscription.prime_ttc + this.fraisLiv) * (0.0125) / (1 - 0.0125);
                    this.fraisPaiement = Math.round(FP * 100) / 100;
                    this.mention_ttc = Math.ceil((this.Devis_pour_souscription.prime_ttc + this.fraisPaiement) + this.fraisLiv)
                }
            },

            calculFraisLiv() {
                let ST = this.mention_ttc;
                let SN = Math.trunc(this.Devis_pour_souscription.prime_ttc);
                let frais = ST - SN;
                this.fraisLiv = frais
            },

            disableExpress() {
                this.disable = true
            },

            enableExpress() {
                this.disable = false
            },

            /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
            onlyNumber($event) {
                let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
                if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
                    $event.preventDefault();
                }
            },

            cancelPaiement() {
                this.adresseLivre = false;
                this.mode_livraison = null;
                this.adresselivraison = ''
            },

            fetchEventsList() 
            {
                this.Mano = this.Mano - 1;
                if (this.Mano == 0) 
                {
                    this.$store.dispatch('setDevis', null);
                    this.$router.push('/')
                }
            },

            isMobile: function () {
                if (screen.width <= 760) {
                    return true;
                } else {
                    return false;
                }
            },

            isDesktop: function () {
                if (screen.width > 760) {
                    return true;
                } else {
                    return false;
                }
            },

            cancelFree() {
                this.freepayment = false,
                this.mode_livraison = null
            },

            showListCity() {
                if (this.prix_livraison == 'dakar_normal' || this.prix_livraison == 'dakar_express') {
                    this.dakar = true;
                    this.ville = this.listVille.Dakar;
                    this.quartier = null
                } else if (this.prix_livraison == 'banlieue_normal' || this.prix_livraison == 'banlieue_express') {
                    this.dakar = true;
                    this.ville = this.listVille.Banlieue;
                    this.quartier = null
                }
            },

            ManipPaiement() {
                const data = { devisid:this.Devis_pour_souscription._id, listPassager:this.tab_perso}
                Api().post('devis/voyage/setpassenger', data)
                .then((result) => {
                    if(result.data.status==1){
                        this.show = false;
                        this.showPaymentBLock = true
                    }else{
                        this.$toasted.show(resp.data.msg, this.ToastTabError);
                    }
                }).catch((err) => {
                        
                });             
            },

            Detail_info_beneficiaires() {
                if (this.nom && this.prenom && this.adresse) {
                    if (this.telephone && this.numero_cni && this.pays && this.genre) {

                        let Un_beneficiaire = {
                            nom: this.nom,
                            prenom: this.prenom,
                            adresse: this.adresse,
                            telephone: this.telephone,
                            numero_cni: this.numero_cni,
                            pays: this.pays,
                            genre: this.genre
                        };

                        if (this.tab_perso.length + 1 <= this.maxPersonne) {
                            this.tab_perso.push(Un_beneficiaire);
                            this.$store.dispatch('setListeBeneficiaire', this.tab_perso);
                            this.showValiderBtn = true;
                            this.nom = '';
                            this.prenom = '';
                            this.adresse = '';
                            this.telephone = '';
                            this.numero_cni = ''
                        } else {
                            this.$toasted.show('Le nombre maximum de personnes est atteind ! ', this.ToastTabError)
                        }

                    } else {
                        this.$toasted.show('Tous les (*) sont obligatoires ! ', this.ToastTabError)
                    }
                } else {
                    this.$toasted.show('Tous les (*) sont obligatoires ! ', this.ToastTabError)
                }
            },

            getImgUrl(pic) {
                if (pic) {
                    return pic
                } else {
                    return require('../assets/img/assuraf_sm.png')
                }
            },

            devisParMail: function (params) {
                Api().get('devis/mydevisbyemail/' + params._id)
                    .then(response => {
                        this.notifDeviSendParMail = response.data.info
                    })
            },

            //=====Paiement via upay =========//
            getPay()
            {
                if (this.mode_payement) 
                {
                    if (this.mode_livraison) 
                    {
                       this.begin_checkoutPushin()
                       getUpay(this.mention_ttc, this.mode_payement)
                    } else {
                        this.$toasted.show("Mode livraison obligatoire !", this.ToastTabError);
                    }
                } else {
                    this.$toasted.show("Mode de payement obligatoire !", this.ToastTabError);
                }
               
            },

            //=====Paiement via inTouch =========//
            getIntoucPay() 
            {
                if (this.mode_payement) {
                    if (this.mode_livraison) {
                        this.begin_checkoutPushin()
                        inTouchSante(this.mention_ttc, this.mode_payement)
                    } else {
                        this.$toasted.show("Mode livraison obligatoire !", this.ToastTabError);
                    }
                } else {
                    this.$toasted.show("Mode de payement obligatoire !", this.ToastTabError);
                }
               
            },
            
            
            /*=====Paiement via Orange Money====*/
            payement_om_start() 
            {
                if (this.mode_payement) 
                {
                    if (this.mode_livraison) 
                    {
                        this.begin_checkoutPushin()
                        let montant = this.mention_ttc;
                        localStorage.setItem('amount', montant);
                        let numDevis = this.Devis_pour_souscription.numeroDevis;
                        localStorage.setItem('numdevis', numDevis);
                        localStorage.setItem('canal', "Orange Money");
                        getOmSante(this.mention_ttc, this.mode_payement)
                    } else {
                        this.$toasted.show("Mode livraison obligatoire !", this.ToastTabError);
                    }
                } else {
                    this.$toasted.show("Mode de payement obligatoire !", this.ToastTabError);
                }
            },

            /*==== Paiement via Orabank ====*/
            payment_Orabank()
            {
                if (this.mode_payement) 
                {
                    if (this.mode_livraison) 
                    {
                        this.begin_checkoutPushin()
                        let montant = this.mention_ttc;
                        localStorage.setItem('amount', montant);
                        let numDevis = this.Devis_pour_souscription.numeroDevis;
                        localStorage.setItem('numdevis', numDevis);
                        localStorage.setItem('canal', "Orabank");
                        getOrabankSante(this.mention_ttc, this.mode_payement);
                        this.$router.push("/payment/orabankrep")
                    } else {
                        this.$toasted.show("Mode livraison obligatoire !", this.ToastTabError);
                    }
                } else {
                    this.$toasted.show("Mode de payement obligatoire !", this.ToastTabError);
                }
            },

            /*==== Paiement via Intouch ===*/
            payement_intouch_start: function () {
                let amout = this.mention_ttc;
                localStorage.setItem('amount', amout);
                let numdevis = this.Devis_pour_souscription.numeroDevis;
                localStorage.setItem('numdevis', numdevis);
                inTouchSante(this.mention_ttc, this.mode_payement);
            },

            /*==== Paiement via Free Money====*/
            payment_free: function () {
                if (this.mode_payement) {
                    if (this.mode_livraison) {
                        this.freepayment = true;
                    } else {
                        this.$toasted.show("Mode livraison obligatoire !", this.ToastTabError);
                    }
                } else {
                    this.$toasted.show("Mode de payement obligatoire !", this.ToastTabError);
                }
            },

            /*==== Paiement via Free Money====*/ 
            Gopayment_free: function () 
            {
                this.snipperfree = true;
                /*On place les variables dans le storage pour les rendre dispo au debut de la transcation*/
                localStorage.setItem('numdevis', this.Devis_pour_souscription.numeroDevis);
                localStorage.setItem('amount', this.mention_ttc);           
                localStorage.setItem('canal', "FreeMoney");
                this.begin_checkoutPushin()
                /*On envois notre 1er request aa l'api free assuraf qui va le transmettre et retourne la reponse*/ 
                freeMoneySante(this.mention_ttc, this.mode_payement, this.numTelephone)
                .then(resp => {
                    if (resp.data) {
                        setTimeout(() => {
                            this.freepayment = false;
                            this.$router.push("/payment/freemoneyrep")
                        }, 50000)
                    }
                })
                .catch(e=>{
                    this.$router.push("/payment/freemoneyrep")
                })
            },


            assistanceDialogManip(devis) {
                this.objetRappel = 'Devis : ' + devis.numeroDevis;
                this.name = store.state.user.prenom.toUpperCase() + '-' + store.state.user.nom.toUpperCase();
                this.tel = store.state.user.telephone_port;
                this.assistanceDialog = true
            },

            AddAssistance() 
            {
                if (this.horaire && this.canal && this.name && this.tel && this.objetRappel && this.remarques) {
                    const assist = {
                        horaire: this.horaire,
                        canal: this.canal,
                        name: this.name,
                        tel: this.tel,
                        objetRappel: this.objetRappel,
                        remarques: this.remarques,
                        userid: store.state.user._id
                    };

                    Api().post('assistances/create', assist)
                        .then(resp => {
                            if (resp.data.info == 'ok') {
                                this.$toasted.show(resp.data.msg, this.ToastTabSucess);
                                this.assistanceDialog = false;
                                this.horaire = '';
                                this.canal = '';
                                this.name = '';
                                this.tel = '';
                                this.objetRappel = '';
                                this.remarques = ''
                            } else if (resp.data.info == 'nok') {
                                this.$toasted.show(resp.data.msg, this.ToastTabError)
                            }
                        })

                } else {
                    this.$toasted.show("Tous les champs sont obligatoires !", this.ToastTabError)
                }

            },

            // Get la liste des pays
            getListePays: function () {
                Api().get('pays')
                    .then(response => {
                        this.countries = response.data
                    })
                    .catch(err => {
                        err
                    })
            },

            getAdressLivraison: function () 
            {
                let delivery_cost = 0
                if (this.prix_livraison) 
                {
                    if (this.prix_livraison == 'dakar_normal') 
                    {
                        delivery_cost = 1500
                        this.mention_ttc = parseInt(this.svgTTC) + 1500
                    } else if (this.prix_livraison == 'dakar_express') 
                    {
                        delivery_cost = 2000
                        this.mention_ttc = parseInt(this.svgTTC) + 2000
                    } else if (this.prix_livraison == 'banlieue_normal') 
                    {
                        delivery_cost = 2000
                        this.mention_ttc = parseInt(this.svgTTC) + 2000
                    } else if (this.prix_livraison == 'banlieue_express') 
                    {
                        delivery_cost = 2500
                        this.mention_ttc = parseInt(this.svgTTC) + 2500
                    }

                    if (this.adresselivraison && this.quartier) 
                    {
                        localStorage.setItem("adressliv", this.adresselivraison);
                        localStorage.setItem("quartier",  this.quartier);
                        localStorage.setItem("typeLivraison",this.prix_livraison)
                        localStorage.setItem("delivery_cost",delivery_cost)
                        this.adresseLivre = false;
                        (localStorage.getItem('adressliv'))
                    } else {
                        this.$toasted.show("Adresse de livraison obligatoire ! ", this.ToastTabError)
                    }
                } else {
                    this.$toasted.show("veuillez choisir un mode de livraison ! ", this.ToastTabError)
                }
                this.calculFraisLiv();

            },

            // Generation du devis en PDF pour download
            telecharger_le_devis: function (params) {
                Api().get('devis/download/' + params._id)
                    .then(response => {
                        let url = response.data.lien;
                        this.dialogLoading = true;
                        setTimeout(() => (
                            this.dialogLoading = false,
                                window.open(url)), 8000);
                    })
            },

            // Validation des champs du formulaire avant payement
            FormFieldsValidation() {
                if (this.nom && this.prenom && this.adresse && this.telephone && this.numero_cni && this.pays) {
                    return true
                } else {
                    return false
                }
            },


            //Date object formater to String
            DateFormater: function (TheDate) {
                if (TheDate) {
                    let laDate = new Date(TheDate);
                    let TheDay = laDate.getDate();
                    let TheMonth = laDate.getMonth() + 1;
                    let TheYear = laDate.getFullYear();
                    if (TheMonth < 10 && TheDay < 10) {
                        return TheYear + '-0' + TheMonth + '-0' + TheDay
                    }
                    if (TheMonth > 10 && TheDay < 10) {
                        return TheYear + '-' + TheMonth + '-0' + TheDay
                    }
                    if (TheMonth < 10 && TheDay > 10) {
                        return TheYear + '-0' + TheMonth + '-' + TheDay
                    } else {
                        return TheYear + '-' + TheMonth + '-' + TheDay
                    }
                }
            },

        },

        beforeDestroy() {
            this.purchasePushinPreparation()
            clearInterval(this.timer)
        },

        watch: {
            notif: function () {
                if (this.notif == 'Contract created') {
                    this.$router.push('/payement/succes');
                    this.notif = null
                } else if (this.notif != 'Contract created') {
                    this.$router.push('/payement/failed');
                    this.notif = null
                }
            },

            showValiderBtn: function (val) {

                if (val == true) {
                    this.$store.dispatch('setListeBeneficiaire', this.tab_perso)
                }

            },

            notifDeviParMail: function () {

                if (this.notifDeviParMail == 'Contrat cree mais non envoye par email') {
                    this.$router.push('/payement/succes');
                    this.notif = null
                } else if (this.notifDeviParMail == 'Contrat cree et envoye par email') {
                    this.$router.push('/payement/succes');
                    this.notif = null
                } else {
                    this.$router.push('/payement/failed');
                    this.notif = null
                }

            },
            notifDeviSendParMail: function () {
                if (this.notifDeviSendParMail == 'ok') {
                    this.$toasted.show('Votre devis vous a été envoyé par email !', this.ToastTabSucess)
                }
            },

            mode_payement:function(val)
            {
                let PayType = ''
                switch (val) 
                {
                    case 'mobile_money': PayType = 'Orange Money';  break;
                    case 'free_money':   PayType = 'Free Money';  break;
                    case 'carte_bancaire':  PayType = 'Carte Bancaire';   break;
                    case 'intouch':         PayType ='Intouch';   break;
                    case 'autre_paiement':  PayType ='Autres paiements mobile'; break;
                }
                this.add_payment_infoPushing(PayType)
            },
       
            mode_livraison: function () {
                this.mention_ttc = parseInt(this.svgTTC);
                this.add_shipping_infoPushing()
                if (this.mode_livraison == 'a_docimicile') {
                    this.adresseLivre = true;
                    this.prix_livraison = null
                } else if (this.mode_livraison == 'reseau_partenaire') {
                    this.mention_ttc = parseInt(this.svgTTC) + 500
                    localStorage.removeItem('adressliv')
                } else if (this.mode_livraison == 'locaux_assuraf') {
                    this.mention_ttc = parseInt(this.svgTTC)
                    localStorage.removeItem('adressliv')
                }
                this.calculFraisLiv();
                this.calculFraisPaiement();
            }
        },

        mounted: function () {
            window.scrollTo(0, 0);
            if (this.$store.state.devis.result.devis.numeroDevis && this.$store.state.user) 
            {
                this.Mano = 15;
                this.getListePays();
                this.mention_ttc = this.$store.state.devis.result.devis.prime_ttc;
                this.svgTTC = this.$store.state.devis.result.devis.prime_ttc;
                this.Devis_pour_souscription = this.$store.state.devis.result.devis;
                this.branche = this.$store.state.devis.result.branche[0].branche;
                this.partenaire = this.$store.state.devis.result.partenaire;
                this.maxPersonne = this.$store.state.devis.result.devis.details_pack_sante.packChoisis[0].nb_personne_max;
                this.tab_pack = this.$store.state.devis.result.devis.details_pack_sante.packChoisis
                                
                let view_itemPushing = {
                    event: 'add_to_cart',
                        ecommerce: {
                            items: [
                                {
                                   'item_name': 'Assurance '+ this.branche.toLowerCase(),
                                    'item_id': this.Devis_pour_souscription.numeroDevis,
                                    'price': Math.ceil(this.mention_ttc/650),
                                    'item_brand': this.partenaire.societe,
                                    'item_category': this.branche,
                                    'item_list_name': 'payment_by_link',
                                    'index': 1,
                                    'quantity': '1'
                                }
                            ]
                        }
                }

                this.addedInTheCard = view_itemPushing

                if(document.readyState=='complete')
                {        
                   PushInDataLayer(view_itemPushing)
                }

            } else {
                this.$router.push('/')
            }
        }
    }
</script>

<style scoped>
    .row-container {
        background: white;
    }

    .container {
        padding: 0px !important;
    }

    .to-left {
        float: left;
    }

    .to-top {
        margin-top: -5%
    }

    .to-right {
        float: right;
        margin-right: -36%
    }

    .to-right-mobile {
        float: right;
        margin-right: -36%;
        font-weight: bold
    }

    .to-left span {
        color: black;
        font-weight: bold;
    }

    .List-cout li {
        list-style: none;
    }

    .list-boutons li {
        list-style: none;
    }

    .logo-assureur {
        border: 1px solid lightgrey;
    }

    .right--texting {
        text-align: right;
    }

    .right--texting ul li .col-lg-6:hover {
        background: #ffa409;
        color: white;
        text-decoration: none;
    }

    .answer {
        position: relative;
        margin-right: 0;
        float: left;
        display: block;
        margin-right: 2.12766%;
        width: 100%;
    }

    .highlight {
        padding: 6px 12px;
        display: -ms-flexbox;
        display: flex;
        position: relative;
        font-size: .0625rem;
        cursor: pointer;
        color: #6d6d6d;
        border: solid 1px transparent;
        border-bottom: solid 1px #e9e9e9;
        border-radius: 3px;
        transition: background .4s;
    }

    .highlight:hover {
        background-color: rgba(255, 164, 9, 0.3);
        padding-left: 10px;
        transition-duration: 0.5s;
    }

    ul li {
        list-style: none;
        padding-top: 7px
    }

    #valeur {
        margin-left: 40%;
    }

    .container {
        padding: 0px !important;
    }

    .uppercase {
        font-weight: bold;
        color: #ffa409;
        text-transform: uppercase;
        font-size: 16px
    }

    .to-left {
        float: right;
        padding-right: 25%
    }

    .to-left-detail {
        float: right;
        padding-right: 5%;
        font-weight: bold;
        color: purple
    }

    .to-left-date {
        float: right;
        padding-right: -5px;
        font-weight: bold;
        color: purple
    }

    .to-left-date-input {
        float: right;
        margin-right: -45px;
        font-weight: bold;
        color: purple
    }

    .head {
        background-color: rgb(91, 148, 188);
        color: white;
        font-size: 18px
    }

    .selectatMobile {
        background: url(https://) no-repeat left;
        -webkit-appearance: none;
        background-position-x: 95%;
        border-bottom: 1px solid gray;
    }

    .selectatDesktop {
        background: url(https://) no-repeat right;
        -webkit-appearance: none;
        background-position-x: 95%;
        border-bottom: 1px solid gray;
    }

    .georgia {
        font-family: Georgia !important;
    }

    .border-radius {
        border-radius: 20px !important
    }

    .to-left {
        text-align: left;
        margin-left: -100px
    }

    .to-right {
        float: right;
    }

    .to-right-mobile {
        float: right;
        margin-right: 2%
    }

    .table-donnees tr td {
        border: 1px solid lightgrey !important;
    }

    .table-donnees tr td {
        border: 1px solid lightgrey !important;
    }

    ul li {
        list-style: none;
        padding-top: 7px
    }

    .row-container {
        background: white;
    }


    .form .plan input, .form .payment-plan input, .form .payment-type input {
        display: none;
    }

    .form label {
        /* margin: 15px; */
        width: 120px;
        position: relative;
        color: #333;
        font-family: Georgia !important;
        border-radius: 20px !important;
        background-color: #fff;
        font-size: 15px;
        text-align: center;
        height: 120px;
        display: block;
        cursor: pointer;
        border: 3px solid transparent;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }

    .form .plan input:checked + label, .form .payment-plan input:checked + label, .form .payment-type input:checked + label {
        border-radius: 20px !important;
        background-color: #ffa409;
        color: #fff;
    }

    .form .plan input:checked + label:after, form .payment-plan input:checked + label:after, .form .payment-type input:checked + label:after {
        content: "\2713";
        width: 40px;
        height: 40px;
        line-height: 40px;
        border-radius: 100%;
        border: 2px solid #ffa409;
        background-color: #fff;
        color: #ffa409;
        z-index: 999;
        position: absolute;
        top: -10px;
        right: -10px;
    }

    .scroll {
        max-height: 450px;
        overflow-y: auto !important;
    }


    /*================== CSS SELECT GLOBAL AUTO===================*/
    /* Reset Select */
    select {
        -webkit-appearance: none;
        -moz-appearance: none;
        -ms-appearance: none;
        appearance: none;
        outline: 0;
        box-shadow: none;

        background: #fff;
    }

    /* Remove IE arrow */
    select::-ms-expand {
        display: none;
    }

    select {
        flex: 1;
        padding: 0 .5em;
        color: grey;
        cursor: pointer;
    }

    /*================== CSS SELECT DESKTOP AUTO===================*/
    /* Custom Select */
    .select {
        position: relative;
        display: flex;
        width: 100%;
        height: 3em;
        line-height: 3;
        background: #fff;
        overflow: hidden;
        border: 2px solid #D3D3D3 !important;
        border-radius: 35px;
    }

    /* Arrow */
    .select::after {
        content: '\2228';
        position: absolute;
        top: 0;
        right: 0;
        padding: 0 1em;
        background: #fff;
        cursor: pointer;
        pointer-events: none;
        -webkit-transition: .25s all ease;
        -o-transition: .25s all ease;
        transition: .25s all ease;
    }

    /* Transition */
    .select:hover::after {
        color: #f39c12;
    }

    /*css popup Free*/

    .containerP {
        margin-top: 15px;
        font-family: PT Sans, sans-serif;
        font-size: 18px;
        max-width: 500px;
        height: 500px;
        background: white;
        border-radius: 9px;
        overflow: hidden;
    }

    .icing,
    .dough {
        float: left;
        padding: 20px;
        box-sizing: border-box;
        height: 100%;
        display: -webkit-box;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        text-align: center;
    }

    .icing {
        width: 33%;
        position: relative;
        padding-right: 24px;
        background: -webkit-gradient(
                linear,
                left top,
                right top,
                from(#ffa409),
                color-stop(100%, #6c757d)
        );
        background: linear-gradient(to right, #ffa409 100%, #6c757d 80%);
        color: white;
    }

    .icing:before {
        content: "";
        width: 36px;
        height: 36px;
        display: block;
        position: absolute;
        top: -18px;
        right: -7.2px;
        z-index: 1;
    }

    .dough {
        width: 67%;
        padding-left: 36px;
        color: black;
    }

    .order {
        -webkit-box-flex: 1;
        flex-grow: 1;
        /* padding: 20px 0;
        margin: 20px 0; */
        border: 1px solid white;
        border-color: white transparent;
        font-weight: bold;
        font-size: 18px;
        text-align: center;
    }

    .order li {
        display: -webkit-box;
        display: flex;
        -webkit-box-pack: justify;
        justify-content: space-between;
        text-align: center;
    }

    h2 {
        font-size: 1.2em;
    }

    .total {
        font-size: 22px;
        text-align: center;
        font-weight: bold;
    }

    .inputs {
        -webkit-box-flex: 1;
        flex-grow: 1;
    }


    .rowFree {
        width: 100%;
        display: -webkit-box;
        display: flex;
        -webkit-box-align: end;
        align-items: flex-end;
        margin-bottom: 6px;
    }

    .rowFreeMobile {
        /* width: 100%; */
        display: -webkit-box;
        display: flex;
        -webkit-box-align: end;
        align-items: flex-end;
        margin-bottom: 6px;
    }

    .column {
        width: 100%;
    }

    .column:not(:last-child) {
        margin-right: 10px;
    }

    .label,
    .text-input {
        float: left;
        display: block;
        clear: both;
    }

    .label {
        font-size: 0.8em;
        margin-bottom: 0.2em;
    }

    .text-input {
        box-sizing: border-box;
        width: 90%;
        padding: 10px;
        font-size: 1em;
        font-family: inherit;
        background: white;
        border: 1px solid #ffa409;
        border-radius: 5px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1) inset;
    }

    .name-group {
        -webkit-box-flex: 1;
        flex-grow: 1;
        flex-basis: 200px;
    }

    .order-button {
        padding: 10px 20px;
        width: 100%;
        box-sizing: border-box;
        font-size: 13px;
        font-family: inherit;
        color: inherit;
        background: rgba(255, 255, 255, 0.5);
        border: 1px solid rgba(144, 81, 14, 0.3);
        box-shadow: 0 2px 2px rgba(144, 81, 14, 0.1);
        border-radius: 5px;
        -webkit-transition: background 0.1s, color 0.1s, border-color 0.1s;
        transition: background 0.1s, color 0.1s, border-color 0.1s;
    }

    .buttonFRMobile {
        padding: 10px 20px;
        width: 100%;
        box-sizing: border-box;
        font-size: 13px;
        font-family: inherit;
        color: inherit;
        background: rgba(255, 255, 255, 0.5);
        border: 1px solid rgba(144, 81, 14, 0.3);
        box-shadow: 0 2px 2px rgba(144, 81, 14, 0.1);
        border-radius: 5px;
        -webkit-transition: background 0.1s, color 0.1s, border-color 0.1s;
        transition: background 0.1s, color 0.1s, border-color 0.1s;
    }

    .order-button:hover {
        background: #ffa409;
        color: white;
        border-color: transparent;
    }

.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}
</style>
